export const mapCategoriesToLinkList = (categories) => {
    const linkList = {};
    for (const category of categories) {
        linkList[category.key] = category.links.map(link => {
            var _a, _b, _c, _d;
            return ({
                id: (_a = link.sitemapNode) === null || _a === void 0 ? void 0 : _a.id,
                url: ((_b = link.sitemapNode) === null || _b === void 0 ? void 0 : _b.absoluteUrl) || '',
                title: link.title || ((_c = link.sitemapNode) === null || _c === void 0 ? void 0 : _c.title) || '',
                presentationFormat: (_d = link.sitemapNode) === null || _d === void 0 ? void 0 : _d.presentationFormat,
            });
        });
    }
    return linkList;
};
//# sourceMappingURL=mapCategoriesToLinkList.js.map